import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'
import moment from 'moment';

import { SingleRedio, SingleText, SingleInput, SingleSelect } from '../../../Res/BaseInput';
import { CancelSubmitButton, Space, EditButton } from '../../../Res/BaseButton';
import { ContentBox } from '../../../Content/ContentBox';
import { SystemPromptInput } from '../../../Res/SystemPrompt';
import { getUserInfo, getUserInfoCompanyId, getval2Token } from '../../../../Login/Auth';
import { api_addRetail, api_getRetailDetail, api_checkRetailHNKID } from '../../../../../api/Beer/apiRetail';
import { getAddrCityList, getAddrDistList, getInChargeDistributionList, getInChargeSalesList, getPurviewString, PURVIEW_DISTRIBUTOR, PURVIEW_MANAGER, PURVIEW_SPECIALIST, ReqRetailDetail, RespRetail, RespRetailInCharge, RetailInChargeType_Distribution, TITLE_InChargeDistribution, TITLE_InChargeSales, TITLE_prompt, TITLE_RetailActivation, TITLE_RetailActivationLastDate, TITLE_RetailAddr, TITLE_RetailAddrCity, TITLE_RetailAddrDist, TITLE_RetailNote } from '../../../../../item/Beer/ItemRetail';
import { get_activation_string, activation_Items, ACTIVATION_ENABLE, ACTIVATION_DISABLE } from '../../../../../item/MyStat/ItemMyStatBase';
import 'rc-datepicker/lib/style.css';
import { TITLE_RetailContact, TITLE_RetailHNKID, TITLE_RetailName, TITLE_RetailPhone, RetailInChargeType_Sales } from '../../../../../item/Beer/ItemRetail';
import { Repeat } from '@material-ui/icons';


export function RetailEdit({ id, setIsLoading, isEdit, isAdd = false, purview = PURVIEW_DISTRIBUTOR }) {
  const [userInfo, setUserInfo] = useState({})
  const [tokenId, setTokenId] = useState("")

  const [_id, set_id] = useState("")
  const [RetailID, set_RetailID] = useState("")
  const [RetailName, set_RetailName] = useState("")
  const [RetailHNKID, set_RetailHNKID] = useState("")
  const [RetailContact, set_RetailContact] = useState("")
  const [RetailPhone, set_RetailPhone] = useState("")
  const [RetailAddrCity, set_RetailAddrCity] = useState("")
  const [RetailAddrCityName, set_RetailAddrCityName] = useState("")
  const [RetailAddrDist, set_RetailAddrDist] = useState("")
  const [RetailAddrDistName, set_RetailAddrDistName] = useState("")
  const [RetailAddr, set_RetailAddr] = useState("")
  const [RetailNote, set_RetailNote] = useState("")
  const [RetailActivation, set_RetailActivation] = useState(1)
  const [RetailActivationLastDate, set_RetailActivationLastDate] = useState("")

  const [InChargeSales, set_InChargeSales] = useState("")
  const [InChargeDistribution, set_InChargeDistribution] = useState("")
  const [InChargeSalesName, set_InChargeSalesName] = useState("")
  const [InChargeDistributionName, set_InChargeDistributionName] = useState("")

  const [AddrCityList, set_AddrCityList] = useState([])
  const [AddrDistList, set_AddrDistList] = useState([])
  const [InChargeSalesList, set_InChargeSalesList] = useState([])
  const [InChargeDistributionList, set_InChargeDistributionList] = useState([])

  const [detail, setDetail] = useState(null)

  const [isCheckRepeat, setCheckRepeat] = useState(false)
  const [isRepeat, setRepeat] = useState(false)
  const [repeatMessage, setRepeatMessage] = useState("")

  useEffect(() => {
    getAddrCityList(setIsLoading, set_AddrCityList)
    switch (purview) {
      case PURVIEW_MANAGER:
        getInChargeSalesList(getUserInfoCompanyId(), setIsLoading, set_InChargeSalesList)
        break;
      case PURVIEW_SPECIALIST:
        console.log("PURVIEW_SPECIALIST")
        var userInfo = getUserInfo()
        setUserInfo(userInfo)
        // console.log(userInfo)
        if (isAdd) {
          set_InChargeSales(userInfo.accountId)
          set_InChargeSalesName(userInfo.nickName)
        }
        break;
      case PURVIEW_DISTRIBUTOR:
        var userInfo = getUserInfo()
        setUserInfo(userInfo)
        console.log(userInfo)
        break;
      default:
        break;
    }
    getInChargeDistributionList(getUserInfoCompanyId(), setIsLoading, set_InChargeDistributionList)
  }, [])

  useEffect(() => {
    if (RetailAddrCity === '')
      return
    getAddrDistList(RetailAddrCity, setIsLoading, set_AddrDistList)
  }, [RetailAddrCity])

  useEffect(() => {
    console.log(id)
    if (id !== undefined && id !== tokenId) {
      var obj = getval2Token("RetailEdit", id)
      console.log(obj)
      set_RetailID(obj.RetailID)
      setTokenId(id)
    }
  }, [id])

  useEffect(() => {
    if (RetailID !== undefined && RetailID !== "") {
      // setIsLoading(true)
      var mReqRetailDetail = new ReqRetailDetail({
        RetailID
      })
      getDetail(mReqRetailDetail)
    }
  }, [RetailID])

  function getDetail(mReqRetailDetail) {
    console.log(mReqRetailDetail)
    setIsLoading(true)
    api_getRetailDetail({
      mReqRetailDetail,
      success: (jsonData) => {
        console.log(jsonData)
        var mRespRetail = new RespRetail({})
        mRespRetail.fromJson(jsonData.detail)

        set_id(mRespRetail._id)
        set_RetailName(mRespRetail.RetailName)
        set_RetailHNKID(mRespRetail.RetailHNKID)
        set_RetailNote(mRespRetail.RetailNote)
        set_RetailContact(mRespRetail.RetailContact)
        set_RetailPhone(mRespRetail.RetailPhone)
        set_RetailAddrCity(mRespRetail.RetailAddrCity)
        set_RetailAddrCityName(mRespRetail.RetailAddrCityName)
        set_RetailAddrDist(mRespRetail.RetailAddrDist)
        set_RetailAddrDistName(mRespRetail.RetailAddrDistName)
        set_RetailAddr(mRespRetail.RetailAddr)
        set_InChargeSales(mRespRetail.InChargeSales)
        set_InChargeSalesName(mRespRetail.InChargeSalesName)
        set_InChargeDistribution(mRespRetail.InChargeDistribution)
        set_InChargeDistributionName(mRespRetail.InChargeDistributionName)
        set_RetailActivation(mRespRetail.RetailActivation)
        set_RetailActivationLastDate(moment(mRespRetail.RetailActivationLastDate).format('YYYY-MM-DD'))

        setDetail(mRespRetail)
        setIsLoading(false)
      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
      }
    })
  }


  function checkRetailHNKID(val) {
    var mRespRetail = new RespRetail({
      RetailHNKID: val,
    })
    console.log(mRespRetail)
    api_checkRetailHNKID({
      mRespRetail,
      success: (jsonData) => {
        console.log(jsonData)
        setCheckRepeat(true)
        if (jsonData.id === "") {
          if (Repeat) {
            setRepeat(false)
          }
          if (repeatMessage !== "")
            setRepeatMessage("")
        } else {
          setRepeat(true)
          setRepeatMessage(<span className="text-danger">不允許重複！！</span>)
        }
      },
      failure: (err) => {
        console.log(err)
        Swal.fire({
          type: 'error',
          title: '提醒',
          text: err,
        })
      }
    })
  }



  function toEdit() {
    window.location.assign("/BeerRetail_Edit_" + getPurviewString(purview) + "/" + id);
  }

  function toCancel() {
    window.history.back();
  }

  function toAdd() {
    // console.log(park_type)
    var inputError = []
    if (RetailName === "") {
      inputError.push(TITLE_RetailName)
    }

    if (inputError.length > 0) {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: inputError.join(',') + ' 為必填',
      })
      return
    }

    var mRespRetail = new RespRetail({
      RetailID,
      RetailName,
      RetailHNKID,
      RetailContact,
      RetailPhone,
      RetailAddrCity,
      RetailAddrDist,
      RetailAddr,
      RetailNote,
      RetailActivation,
      RetailActivationLastDate,
    })

    var mRespRetailInChargeList = []
    if (InChargeSales !== "") {
      mRespRetailInChargeList.push(
        new RespRetailInCharge({
          RetailInChargeType: RetailInChargeType_Sales,
          RetailID,
          RetailInChargeStaffID: InChargeSales,
          isEffective: 1
        })
      )
    }

    if (InChargeDistribution !== "") {
      mRespRetailInChargeList.push(
        new RespRetailInCharge({
          RetailInChargeType: RetailInChargeType_Distribution,
          RetailID,
          RetailInChargeStaffID: InChargeDistribution,
          isEffective: 1
        })
      )
    }

    console.log(mRespRetail)
    console.log(mRespRetailInChargeList)
    setIsLoading(true)
    api_addRetail({
      isAdd,
      Retail: mRespRetail,
      InCharges: mRespRetailInChargeList,
      success: (jsonData) => {
        setIsLoading(false)
        Swal.fire({
          type: 'success',
          title: '提醒',
          text: isAdd ? '新增成功' : '修改成功',
        }).then(function () {
          toCancel()
        })
      },
      failure: (err) => {
        setIsLoading(false)
        Swal.fire({
          type: 'error',
          title: '提醒',
          text: err,
        })
      }
    })
  }

  var title = "客戶資料"
  var content =
    <>
      <div className="row">
        <div className="col-sm-12">

          {isEdit ?
            <SingleInput title={TITLE_RetailName} val={RetailName} action={set_RetailName} placeholder={"EX：XXX居酒屋"} size={4} />
            : <SingleText title={TITLE_RetailName} val={RetailName} size={4} />
          }
          {isEdit ?
            <SingleInput title={TITLE_RetailContact} val={RetailContact} action={set_RetailContact} placeholder={"EX：張店長"} size={2} />
            : <SingleText title={TITLE_RetailContact} val={RetailContact} size={2} />
          }
          {isEdit ?
            <SingleInput title={TITLE_RetailPhone} val={RetailPhone} action={set_RetailPhone} placeholder={"EX：022528XXXX"} size={2} />
            : <SingleText title={TITLE_RetailPhone} val={RetailPhone} size={2} />
          }

          {isAdd || (isEdit && purview === PURVIEW_MANAGER) ?
            <SingleInput title={<>{TITLE_RetailHNKID}&nbsp;&nbsp;&nbsp;&nbsp;{repeatMessage}</>} val={RetailHNKID} action={set_RetailHNKID} action_blur={checkRetailHNKID} placeholder={"EX：HNK0039099"} size={4} />

            : <SingleText title={TITLE_RetailHNKID} val={RetailHNKID} size={4} />
          }
        </div>
        <Space />
        <Space />
        <Space />
        <div className="col-sm-12">
          {isEdit ?
            <SingleSelect title={TITLE_RetailAddrCity}
              val={RetailAddrCity}
              attr={AddrCityList}
              action={set_RetailAddrCity}
              v={'AddrCityID'}
              n={'AddrCityName'}
              hasBlank={true}
              size={2}
            />
            : <SingleText title={TITLE_RetailAddrCity} val={RetailAddrCityName} size={2} />
          }
          {isEdit ?
            <SingleSelect title={TITLE_RetailAddrDist}
              val={RetailAddrDist}
              attr={AddrDistList}
              action={set_RetailAddrDist}
              v={'AddrDistID'}
              n={'AddrDistName'}
              hasBlank={true}
              size={2}
            />
            : <SingleText title={TITLE_RetailAddrDist} val={RetailAddrDistName} size={2} />
          }
          {isEdit ?
            <SingleInput title={TITLE_RetailAddr} val={RetailAddr} action={set_RetailAddr} placeholder={"EX：台北市大安區仁愛路四段XXX號"} size={4} />
            : <SingleText title={TITLE_RetailAddr} val={RetailAddr} size={4} />
          }
          {isEdit ?
            <SingleInput title={TITLE_RetailNote} val={RetailNote} action={set_RetailNote} placeholder={"EX：可填寫該客戶的特殊要求"} size={4} />
            : <SingleText title={TITLE_RetailNote} val={RetailNote} size={4} />
          }
        </div>
        <div className="col-sm-12">
          <div className="hr-line-dashed"></div>
        </div>
        <div className="col-sm-12">
          {purview === PURVIEW_SPECIALIST || checkPurview_D()
            ? <SingleText title={TITLE_InChargeSales} val={InChargeSalesName} size={2} />
            : isEdit ?
              <SingleSelect title={TITLE_InChargeSales}
                val={InChargeSales}
                attr={InChargeSalesList}
                action={set_InChargeSales}
                v={'accountId'}
                n={'nickName'}
                hasBlank={true}
                size={2}
              />
              : <SingleText title={TITLE_InChargeSales} val={InChargeSalesName} size={2} />
          }
          {checkPurview_D()
            ? <SingleText title={TITLE_InChargeDistribution} val={InChargeDistributionName} size={2} />
            : isEdit ?
              <SingleSelect title={TITLE_InChargeDistribution}
                val={InChargeDistribution}
                attr={InChargeDistributionList}
                action={set_InChargeDistribution}
                v={'departmentId'}
                n={'departmentName'}
                hasBlank={true}
                size={2}
              />
              : <SingleText title={TITLE_InChargeDistribution} val={InChargeDistributionName} size={2} />
          }
          <SingleText title={TITLE_prompt} val={'該客戶之銷售量，歸“所屬業務員”之業績，且預設由“所屬經銷商”負責服務。'} size={8} />

        </div>
        <div className="col-sm-12">
          <div className="hr-line-dashed"></div>
        </div>
        <div className="col-sm-12">
          {
            isEdit ?
              <SingleRedio title={TITLE_RetailActivation}
                arr={activation_Items}
                val={RetailActivation ? ACTIVATION_ENABLE : ACTIVATION_DISABLE}
                action={set_RetailActivation}
                size={2}
              />
              :
              <SingleText title={TITLE_RetailActivation}
                val={get_activation_string(RetailActivation)}
                size={2} />
          }
          {isAdd ?
            <div className="col-sm-2"></div>
            : <SingleText title={TITLE_RetailActivationLastDate} val={RetailActivationLastDate} size={2} />
          }
          <SingleText title={TITLE_prompt} val={'停用後，除了機器服務單之“拆機服務”，對該客戶不得再有任何新服務。'} size={8} />

        </div>
        {isCheckRepeat ?
          <div className="row">
            <div className="col-md-4">
              <p className={isRepeat ? "text-danger" : "text-info"}>{repeatMessage}</p>
            </div>
          </div>
          : <></>}
      </div>
    </>

  var footer =
    <div className="row">
      <div className="col-sm-12">
        {
          getFooter()
        }
      </div>
    </div>

  function checkPurview_D() {
    return purview === PURVIEW_DISTRIBUTOR
  }

  function getFooter() {
    if (checkPurview_D()) {
      if (userInfo.departmentId === InChargeDistribution) {
        return <EditButton action={toEdit} isRight={true} />
      } else {
        return <></>
      }
    } else {
      if (isAdd || isEdit) {
        return <div className="col-sm-3 col-sm-offset-9">
          <CancelSubmitButton cancelAction={toCancel} submitName={"儲存"} submitAction={toAdd} isRight={true} />
        </div>
      } else {
        // console.log("InChargeSales : "+InChargeSales)
        // console.log(userInfo)
        if (purview === PURVIEW_SPECIALIST && userInfo.accountId !== InChargeSales) {
          return <></>
        } else
          return <EditButton action={toEdit} isRight={true} />
      }
    }
  }

  return (
    <>
      <ContentBox title={title} content={content} footer={footer} hasDrawer={false} />
      <SystemPromptInput />
    </>
  )
}